<template>
  <div class="checkbox">
    <input
      :id="id"
      :checked="value"
      type="checkbox"
      @change="handleChange"
    />
    <IconCheckbox
      :color="color"
      :checked="value"
    />
  </div>
</template>

<script>
import IconCheckbox from '@/components/icons/IconCheckbox.vue';

export default {
  name: 'Checkbox',
  components: {
    IconCheckbox,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '#3E9AA6',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleChange(event) {
      const { checked } = event.target;
      this.$emit('input', checked);
      this.$emit('change', checked);
    },
  },
};
</script>

<style scoped lang="scss">
.checkbox {
  cursor: pointer;

  input {
    opacity: 0;
    position: absolute;
    z-index: -1;

    &:focus ~ .icon {
      outline: 1px solid #000;
    }
  }

  .icon {
    display: block;
  }
}
</style>
